export const about_items = [
  {
    title: "The Company",
    description:
      "JK Millennium Computer Centre is an Information & Communication Technology (ICT) company in Kuching, Sarawak which provides a single source of expertise and valued propositions to its customers in East Malaysia.",
  },
  {
    title: "History",
    description:
      "JK Millenium was incorporated in the year 2000 as a partnership company.",
  },
  {
    title: "Mission",
    description:
      "Our mission is to provide the best quality products and services to our customers.",
  },
];

export const auth_reseller_list = [
  "/images/auth-reseller/access.webp",
  "/images/auth-reseller/acer.webp",
  "/images/auth-reseller/apc.webp",
  "/images/auth-reseller/asus.webp",
  "/images/auth-reseller/autocount.webp",
  "/images/auth-reseller/brother.webp",
  "/images/auth-reseller/camnix.webp",
  "/images/auth-reseller/dahua.webp",
  "/images/auth-reseller/dell.webp",
  "/images/auth-reseller/epson.webp",
  "/images/auth-reseller/grandstream.webp",
  "/images/auth-reseller/hp.webp",
  "/images/auth-reseller/kaspersky.webp",
  "/images/auth-reseller/microsoft.webp",
  "/images/auth-reseller/neuropower.webp",
  "/images/auth-reseller/panda.webp",
  "/images/auth-reseller/sophos.webp",
  "/images/auth-reseller/tp-link.webp",
];

export const product_lists = [
  {
    id: 1,
    name: "Desktop",
    brands: [
      {
        name: "Acer Desktop",
        image: "/images/item-image/desktops/acer.webp",
        link: "",
      },
      {
        name: "Asus Desktop",
        image: "/images/item-image/desktops/asus.webp",
        link: "",
      },
      {
        name: "Dell Desktop",
        image: "/images/item-image/desktops/dell.webp",
        link: "",
      },
      {
        name: "HP Desktop",
        image: "/images/item-image/desktops/hp.webp",
        link: "",
      },
      {
        name: "Custom Built",
        image: "/images/item-image/desktops/custom.webp",
        link: "",
      },
    ],
  },
  {
    id: 2,
    name: "Laptop",
    brands: [
      {
        name: "Acer",
        image: "/images/item-image/laptops/acer.webp",
        link: "",
      },
      {
        name: "Asus",
        image: "/images/item-image/laptops/asus.webp",
        link: "",
      },
      {
        name: "Dell",
        image: "/images/item-image/laptops/dell.webp",
        link: "",
      },
      {
        name: "HP",
        image: "/images/item-image/laptops/hp.webp",
        link: "",
      },
      {
        name: "MSI",
        image: "/images/item-image/laptops/msi.webp",
        link: "",
      },
    ],
  },
  {
    id: 3,
    name: "Printer and Scanner",
    brands: [
      {
        name: "Brother",
        image: "/images/item-image/printers/brother.webp",
        link: "",
      },
      {
        name: "Canon",
        image: "/images/item-image/printers/canon.webp",
        link: "",
      },
      {
        name: "Epson",
        image: "/images/item-image/printers/epson.webp",
        link: "https://www.epson.com.my/printer-page",
      },
    ],
  },
  {
    id: 4,
    name: "Projector",
    brands: [
      {
        name: "Acer",
        image: "/images/item-image/projectors/acer.webp",
        link: "",
      },
      {
        name: "BenQ",
        image: "/images/item-image/projectors/benq.webp",
        link: "https://www.benq.com/en-my/projector.html",
      },
      {
        name: "Epson",
        image: "/images/item-image/projectors/epson.webp",
        link: "https://www.epson.com.my/projector-page",
      },
    ],
  },
  {
    id: 5,
    name: "Software",
    brands: [
      {
        name: "AutoCount",
        image: "/images/item-image/software/autocount.webp",
        link: "https://www.autocountsoft.com",
      },
      {
        name: "Access UBS",
        image: "/images/item-image/software/access-ubs.webp",
        link: "",
      },
      {
        name: "Microsoft Office",
        image: "/images/item-image/software/office.webp",
        link: "https://www.microsoft.com/en-my/microsoft-365/microsoft-office",
      },
      {
        name: "Microsoft Windows",
        image: "/images/item-image/software/windows.webp",
        link: "https://www.microsoft.com/en-us/windows?r=1",
      },
      {
        name: "Panda Antivirus",
        image: "/images/item-image/software/panda.webp",
        link: "",
      },
      {
        name: "Kaspersky Antivirus",
        image: "/images/item-image/software/kaspersky.webp",
        link: "",
      },
      {
        name: "Sophos Antivirus",
        image: "/images/item-image/software/sophos.webp",
        link: "https://www.sophos.com/en-us/products/endpoint-antivirus",
      },
    ],
  },
  {
    id: 6,
    name: "Accessories",
    brands: [
      {
        name: "Cables",
        image: "/images/item-image/accessories/cables.webp",
        link: "",
      },
      {
        name: "Inkjet Ink",
        image: "/images/item-image/accessories/inks.webp",
        link: "",
      },
      {
        name: "Mouse and Keyboards",
        image: "/images/item-image/accessories/mnk.webp",
        link: "",
      },
      {
        name: "Ribbon",
        image: "/images/item-image/accessories/ribbon.webp",
        link: "",
      },
      {
        name: "Router",
        image: "/images/item-image/accessories/router.webp",
        link: "",
      },
      {
        name: "Switch",
        image: "/images/item-image/accessories/switch.webp",
        link: "",
      },
      {
        name: "Storage Device",
        image: "/images/item-image/accessories/storage.webp",
        link: "",
      },
      {
        name: "Toner",
        image: "/images/item-image/accessories/toner.webp",
        link: "",
      },
      {
        name: "Uninterruptable power supply (UPS)",
        image: "/images/item-image/accessories/ups.webp",
        link: "",
      },
      {
        name: "USB Hub",
        image: "/images/item-image/accessories/usb-hub.webp",
        link: "",
      },
    ],
  },
  {
    id: 7,
    name: "Network",
    brands: [
      {
        name: "Servers",
        image: "/images/item-image/network/server.webp",
        link: "",
      },
      {
        name: "Server Racks",
        image: "/images/item-image/network/racks.webp",
        link: "",
      },
      {
        name: "Sophos Firewall",
        image: "/images/item-image/network/firewall.webp",
        link: "https://www.sophos.com/en-us/products/next-gen-firewall",
      },
    ],
  },
  {
    id: 8,
    name: "Security",
    brands: [
      {
        name: "Access Numpads",
        image: "/images/item-image/security/access.webp",
        link: "",
      },
      {
        name: "Alarm Systems",
        image: "/images/item-image/security/alarm.webp",
        link: "",
      },
      {
        name: "Attendance Systems",
        image: "/images/item-image/security/attendance.webp",
        link: "",
      },
      {
        name: "CCTV Cameras",
        image: "/images/item-image/security/cctv.webp",
        link: "",
      },
      {
        name: "Video Recorders",
        image: "/images/item-image/security/recorder.webp",
        link: "",
      },
      {
        name: "PA Systems",
        image: "/images/item-image/security/pa-system.webp",
        link: "",
      },
    ],
  },
];

export const services = [
  {
    id: 1,
    title: "Computer Supply & Setup",
    description:
      "From desktops to laptops, we provide and configure devices for all environments.",
    icon: "qlementine-icons:computer-16",
  },
  {
    id: 2,
    title: "CCTV Surveillance",
    description:
      "Professional installation and support for modern security camera systems.",
    icon: "ph:security-camera-light",
  },
  {
    id: 3,
    title: "Alarm & Security Systems",
    description:
      "Secure your premises with smart alarms, motion detectors, and control panels.",
    icon: "mdi:security",
  },
];
